import { Box, Modal } from "@mui/material";
import Logo from "../../components/image/bfiloader.gif";
const LoaderModal = ({ loading }) => {
  return (
    <Modal open={loading}>
      <Box
        style={{
          width: "100%",
          height: "100vh",
          border: "2px solid cadetblue",
          padding: "30px",
          textAlign: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <div
          style={{
            background: "#fff",
            padding: "2rem 4rem",
            borderRadius: "20px",
            display: "grid",
          }}
        >
          <img
            src={Logo}
            alt="logo"
            style={{ height: "150px", borderRadius: "5%" }}
          />
        </div>
      </Box>
    </Modal>
  );
};

export default LoaderModal;
